import { callApi } from "Apis";
import { ADDONSURL } from "helpers/constant";

export async function addOnsList(data) {
  try {
    const response = await callApi({ url: ADDONSURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function addOnsAdd(data) {
  try {
    const response = await callApi({ url: ADDONSURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getAddOnsById(id) {
  try {
    const response = await callApi({ url: ADDONSURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateAddOns(data) {
  try {
    const response = await callApi({ url: ADDONSURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteAddOnsById(id) {
  try {
    const response = await callApi({ url: ADDONSURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function addOnsOption() {
  try {
    const response = await callApi({ url: ADDONSURL.OPTION, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
